import React, { useContext } from 'react';
import Button from '@/components/Button/Button';
import t from '@/utils/Language/UI-translations';
import { viewportContext } from '@/context/viewport.context';
import { useRouter } from 'next/router';

const BackButton = ({ additionalClasses }, ...props) => {
  const router = useRouter();
  const { unusedIsPhone, unusedIsXSPhone } = useContext(viewportContext);

  return (
    <Button
      type="default"
      text={unusedIsPhone || unusedIsXSPhone ? '' : t('Back')}
      icon={{ style: 'fas', font: 'chevron-left', position: 'left' }}
      onButtonClick={() => router.back()}
      additionalClasses={additionalClasses}
    />
  );
};

BackButton.propTypes = {};

BackButton.defaultProps = {};

export default BackButton;
